export default {
  CreateRule: 'Create New Rule',
  EditRule: 'Edit rule',
  BatchAssociatedGateway: 'Bule Associate Gateway',
  SearchRuleName: 'Search Rule name/Associate Gateway/Branch/Source IP/Target IP/Domain Name',
  RuleName: 'Rule Name',
  Priority: 'Priority',
  CreateTime: 'Created Time',
  GateWay: 'Assciated Gateway',
  UserId: 'User ID',
  Role: 'User Role',
  Operating: 'Operating',
  TotalItem: (val: number) => `Total ${val} Items`,
  Edit: 'Edit',
  Delete: 'Delete',
  IsDeleteRule: 'Are you sure you want to delete?',
  Sure: 'Confirm',
  Cancel: 'Cancel',
  SrcIp: 'Source ip',
  SrcPort: 'Source Port',
  DestIp: 'Destination IP',
  DestPort: 'Destination Port',
  DeleteSuccess: 'Delete success',
  DeleteError: 'Delete error, please try again',
  RelatSuccess: 'Associate success',
  RelatedGateway: 'Associated Gateway',
  ConfiguredRules: 'Configured Rules',
  PriorityPromp: 'Priority is a positive integer from 1 to 50',
  ChangeSuccess: 'Modification Success',
  AddSuccess: 'Add Success',
  SettingRule: 'Set Rules',
  Next: 'Next Step',
  Previous: 'Back',
  PleaseSelect:'Please select',
  PleaseSelectApp:'Please select an application',
  BaseOnFiveTuple:'Based on the 5-tuple',
  BaseOnApp: 'Based on App DPI',
  PleaseWrite:'Please input',
  PlotNameExamp: 'Supports 2-20 characters of Chinese, English, numbers and underscores',
  RuleType:'Rule Type',
  RuleTypeMsg:'Please select the rule type',
  ProtocolType:'Protocol Type',
  Protocol: 'Protocol',
  SelectProtocolType:'Please select the protocol type',
  SrcIpInputMsg:'Please input the source IP',
  SrcIpPH:'Please input a single IP address or CIDR segment format',
  IpExamp: ' Example:192.168.10.10 or 192.168.10.0/24',
  IPv6Examp: ' Example:fc00:db8:0:200::96 or fc00:db8:0:200::96/64',
  SrcPortInputMsg:'Please input the source port',
  SrcPortPH:'Please input the port range, which ranges from 1 to 65535',
  PortExamp: 'Example:1/200 or 80',
  DestIpMsg:'Please input the destination ip',
  DestPortMsg:'Please input the destination port',
  OriginIpToolTip1: 'Outbound direction: The network segment where the source address of the local branch initiated the access. ',
  OriginIpToolTip2: 'Inbound direction: The network segment where the source address from which the access was initiated from outside.  ', // source ip input box prompt information
  TargetIpToolTip1: 'Outbound direction: The external destination segment to access. ',
  TargetIpToolTip2: 'Inbound direction: The target segment of the local branch to be accessed. ',
  Unfold: 'Expand',
  PutAway: 'Fold',
  GatewayName:'Gateway Name',
  DeviceName:'Device Name',
  SelectGateway:'Choose an associated gateway',
  Selected: 'Selected',
  RelatedRules: 'Associated rule number',
  PriorityExamp: 'The smaller the value, the higher the priority. The same priority value will take effect according to the earlier creation time.',
  CurrentRuleRelated: 'The current rule is associated with multiple gateways, please go to ',
  AloneSet: 'Individual settings', // CurrentRuleRelated和AloneSet本为一句话，由于中间有可点击链接，所以拆开，原句为：当前规则关联多条网关，请前往已关联网关单独设置
  UnLimit: 'Unlimited',
  Export: 'Export',
  Exporting: 'Exporting',
  ExportSuccess: 'Export Success',
  MaxExportLength: 'If the quantity exceeds $1, the export time may be longer',
  Today: 'Today',
  Yesterday: 'Yesterday',
  IPErrorTips: 'Input format error, please correct',
  NearlyDay: (date: number) => `Past ${date} days`,
  Remove: 'Remove',
  IsRemoveRule: 'Are you sure you want to remove?',
  RemoveSuccess: 'Remove Success',
  RemoveError: 'Removal failed, please try again later',
  GatewayList: 'Gateway Instance',
  AccessControl: 'Access Control',
  Qos: 'QoS Policy',
  FlowLog: 'Traffic Record',
  ControlLog: 'Control Log',
  Wait: 'Wait for ',
  Item: 'items', // wait和item本为一句话，由于中间穿插了ReactElement所以拆分，原句为等num个
  IPError: 'IP format error',
  PortError: 'Port format error',
  FlowControl: 'Traffic control',
  AccountCenter: 'Account center',
  SafeSet: 'Security settings',
  Exit: 'Exit',
  BaishanCloud: 'BaishanCloud',
  UserName: 'User name',
  Save: 'Save ',
  PurchaseBandwidth: 'Purchase bandwidth',
  NoData: 'No data',
  Individual: 'item',
  Cpe: 'Device',
  AccessRule: 'Access control rules',
  Overview: 'Overview',
  IpNotEqual: 'The origin IP cannot be the same as the target IP',
  PortRange: 'The port number range should be from small to large',
  NameWarning: 'Name must be 2-20 characters in English and Chinese, numbers, underscores, minus signs',
  OperationSuccessful: 'Operation success',
  OperationFailed: 'Operation failed',
  PurchaseAllBandwidth: 'Purchase total bandwidth',
  DefaultPriority: 'Default priority',
  ALL: 'All',
  EditSuccess: 'Edit success',
  NetPartRange: 'The network segment range is 1-32',
  SearchGatewayName: 'Search for gateway name/device name',
  Minute: 'minutes',
  NextErrorTip: 'In order to guarantee the effectiveness of access control, the 5-tuple information (in addition to the protocol) needs to be restricted to at least one',
  MaxRuleNum: (val: number) => `The maximum number of associated rules is ${val}`,
  RelatedQos: 'The number od associated policies',
  MaxQosNum: 'The same gateway can only be associated with a maximum of 10 policies',
  SearchNetName: 'Search gateway name',
  BatchControl: 'Batch management',
  RelationErr: 'Association Error',
  DeletedNoRestore: 'You cannot restore after delete, please re-add if necessary',
  isRequireNotBlank: (title: string) => `${title} does not support blank, please modify`,
  SaveSuccess: 'Save Success',
  Refresh: 'Refresh',
  Interface: 'Interface',
  Modify: 'Modify',
  Config: 'Configure',
  Enable: 'Enable',
  StopUsing: 'Suspend',
  Close: 'Disable',
  Open: 'Enable',
  OrderNumber: 'Order Number',
  AddPolicy: 'Create New Policy',
  EditPolicy: 'Edit policy',
  IPAddressError: 'The input format is wrong, please fill in the correct IP address or address segment',
  Remark: 'Remark',
  ConfigModifySuccess: 'Configure modification success',
  PriorityInvalid: 'Priority is a positive integer from 1 to 200',
  WeightInvalid: 'Weight is a positive integer from 1-3',
  Status: 'Status',
  Mapping: 'Mapping',
  NotConfigured: 'Not configured',
  Configured: 'Configured',
  Setting: 'Setting',
  Success: 'Success',
  PleaseAddFirst: 'Please add first',
  Rule: 'Rule',
  PortValueErrorTips: 'The port value range is 1 to 65535',
  SituationCenter: 'Status Center',
  BranchType: 'Branch Type',
  China: 'China',
  PleaseInput: 'Please input',
  Attention: 'Attention',
  Document: 'Document',
  Normal: 'Normal',
  BreakDown: 'Fault',
  GatewayID:'Gateway ID',
  Branch: 'Branch',
  CurrentPriority:'Current Priority',
  AssociatedDevices: 'Associated Devices',
  ClearAllPlaceholder: 'Are you sure to clear all selected items?',
  Clear: 'Clear',
  Switch: 'Switch',
  APP: 'App',
  Type: 'Type',
  Map: 'Map',
  NetworkTopology: 'Network topology',
  Start: 'Start',
  Stop: 'Stop',
  OperationLog: 'Operation Log',
  UserBehaviorLog: 'UserBehavior Log',
  CrossBorder: 'Cross Border',
  ChannelManagement: 'Channel management',
  PopServers: 'Pop Information',
  PrivateLine: 'Line Information',
  UserOrder: 'Order List',
  Channel: 'Channel',
  UserWhitelist: 'User whitelist',
  Detail: 'Detail',
  NetTopology: 'Net Topology',
  Permission: 'Permission',
  LineStatus: 'Line status',
  Search: 'Search',
  GatewayPurchaseAllBandwidth: 'Gateway Purchase total bandwidth',
  Globe: 'Globe',
  Abnormal: 'Abnormal',
  DialTestTask: 'Dial test task',
  Add: 'Add',
  Port: 'Port',
  DomainName: 'domain name',
  Time: 'Time',
  Optional: 'Optional',
  Client: 'Client',
  SubAccount: 'Sub-account',
  MainAccount: 'Main-account',
  MaxLength: (num: number) => `Supports up to ${num} items`,
  SrcHasEqualDest: (ip: string) => `The source ip and target ip have the same ip: ${ip}`,
  Example: 'Example',
}